export const Segmented = ({ value, onChange, options, testid }) => (
  <div className="grid grid-flow-col auto-cols-fr gap-1 p-1 bg-white border border-slate-300" data-testid={testid} role="radiogroup">
    {options.map((o) => {
      const active = value === o.value;
      return (
        <button key={o.id} type="button" role="radio" aria-checked={active} onClick={() => onChange(o.value)}
          data-testid={`${testid}-${o.id}`}
          className={`h-9 px-2 text-xs sm:text-sm font-display uppercase tracking-wider font-semibold transition-colors ${active ? "bg-amber-500 text-[#0B1017]" : "text-slate-700 hover:bg-slate-100"}`}>
          {o.label}
        </button>
      );
    })}
  </div>
);

export const YES_NO = [{ value: true, label: "Yes", id: "yes" }, { value: false, label: "No", id: "no" }];
export const TRANSPORT = [{ value: "open", label: "Open", id: "open" }, { value: "enclosed", label: "Enclosed", id: "enclosed" }];
